const isBrowser = (): boolean => {
  try {
    return typeof window !== 'undefined'
  } catch (_) {
    return false
  }
}

export const IS_BROWSER = isBrowser()
